import { ModalType } from "../../../../../Types/UserProfileDetails";
import { AppDispatch } from "../../../../../ReduxToolkit/Store";
import { selectTeamMembersAttendanceList } from "../../redux/selector/teamMembersAttendanceListSelector";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { dateConversion } from "../../../../../utils/dateUtils";
import ExportDialog from "../../../../../CommonElements/ExportDialog";
import { IAttendanceRequestData } from "../../types";

export interface IExportHandlerProps {
  modalType: ModalType | null;
  isOpen: boolean;
  dispatch: AppDispatch;
}

const AttendanceExportReportDialog = ({
  modalType,
  isOpen,
  dispatch,
}: IExportHandlerProps) => {
  const teamMembersAttendanceList = useAppSelector(
    selectTeamMembersAttendanceList
  );

  const handleTransformList = (list: IAttendanceRequestData[]) =>
    list.map((teamMembers, i) => ({
      "S.No": i + 1,
      Date: dateConversion(teamMembers.date) || "",
      "Employee Code": teamMembers.team_member.emp_code || "",
      "Employee Name": teamMembers.team_member.name || "",
      Managers: teamMembers.managers || "",
      "In Time": teamMembers.in_time || "",
      "Out Time": teamMembers.out_time || "",
      Status: teamMembers.status || "",
      Reason: teamMembers.reason || "",
    }));

  return (
    <ExportDialog
      isOpen={isOpen}
      dispatch={dispatch}
      addDateSuffix={true}
      sheetName="Attendance Correction Request"
      dialogLabel="Do you want to export the Employee's Attendance Correction Requests report?"
      fileName="Employee Attendance Correction List.xlsx"
      modalType={modalType}
      data={teamMembersAttendanceList?.data || []}
      transform={handleTransformList}
      targetModalType="exportEmployeeAttendanceCorrectRequest"
    />
  );
};

export default AttendanceExportReportDialog;
